import React from 'react'
import { LoadingSpinner } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'

const PrivacySpinner = () => (
  <div className="privacy-spinner">
    <LoadingSpinner
      size="lg"
      screenReaderText={
        <Message id="privacySettings.loader.screenReader.text" />
      }
    />
  </div>
)

export default PrivacySpinner
